"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigations = exports["default"] = void 0;
var _noSidebar = _interopRequireDefault(require("./noSidebar"));
var _withSidebar = _interopRequireDefault(require("./withSidebar"));
var _progress = _interopRequireDefault(require("./progress"));
var _curriculum = _interopRequireDefault(require("./curriculum"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var builtInNavigations = [_noSidebar["default"], _withSidebar["default"], _progress["default"], _curriculum["default"]];
var appNavigations = function () {
  var context = require.context('resources/assets/js', true, /^\.\/vendor\/assignment\/navigations\.js$/);
  if (context.keys().length > 0) {
    var filematches = context(context.keys()[0]);
    return filematches["default"] || filematches;
  }
  return [];
}();
var allNavigations = [].concat(builtInNavigations, _toConsumableArray(appNavigations));

/* keeping this default export to keep backwards compatibility with any apps
 * that import from cccisd-laravel-assignment/dist folder. Moving forward,
 * we should always be using getNavigations function instead.
 */
var _default = allNavigations;
exports["default"] = _default;
var getNavigations = function getNavigations() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    noCurriculum = _ref.noCurriculum,
    noCourseWrapper = _ref.noCourseWrapper,
    restrictionsLevel = _ref.restrictionsLevel,
    requiredNavigation = _ref.requiredNavigation;
  if (['basic', 'premium'].includes(restrictionsLevel)) {
    return allNavigations.filter(function (nav) {
      return ['noSidebar', 'withSidebar', 'progress'].includes(nav.handle) || nav.handle === requiredNavigation;
    });
  }

  // must be explicitly true, by default show all navigations
  return allNavigations.filter(function (nav) {
    return !noCurriculum || !nav.handle.startsWith('curriculum');
  }).filter(function (nav) {
    return !noCourseWrapper || !nav.handle.startsWith('courseWrapper');
  });
};
exports.getNavigations = getNavigations;